import { render, staticRenderFns } from "./JuntasSomos+.vue?vue&type=template&id=b285dd4e"
import script from "./JuntasSomos+.vue?vue&type=script&lang=js"
export * from "./JuntasSomos+.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports